"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = !0;
exports.default = void 0;

var _ExternalLink = _interopRequireDefault(require("./ExternalLink"));

var _Cancel = _interopRequireDefault(require("./Cancel"));

var _Cross = _interopRequireDefault(require("./Cross"));

var _Clock = _interopRequireDefault(require("./Clock"));

var _Chevron = require("./Chevron");

var _Delete = _interopRequireDefault(require("./Delete"));

var _Info = _interopRequireDefault(require("./Info"));

var _Highlight = _interopRequireDefault(require("./Highlight"));

var _Spinner = _interopRequireDefault(require("./Spinner"));

var _Question = _interopRequireDefault(require("./Question"));

var _Arrow = _interopRequireDefault(require("./Arrow"));

var _Car = _interopRequireDefault(require("./Car"));

var _Boat = _interopRequireDefault(require("./Boat"));

var _Home = _interopRequireDefault(require("./Home"));

var _Legal = _interopRequireDefault(require("./Legal"));

var _Business = _interopRequireDefault(require("./Business"));

var _Health = _interopRequireDefault(require("./Health"));

var _Cost = _interopRequireDefault(require("./Cost"));

var _Education = _interopRequireDefault(require("./Education"));

var _Life = _interopRequireDefault(require("./Life"));

var _Print = _interopRequireDefault(require("./Print"));

var _Tick = _interopRequireDefault(require("./Tick"));

var _Pencil = _interopRequireDefault(require("./Pencil"));

var _TextBox = _interopRequireDefault(require("./TextBox"));

var _TickCircle = _interopRequireDefault(require("./TickCircle"));

var Icons = {
  Arrow: _Arrow.default,
  Cancel: _Cancel.default,
  Clock: _Clock.default,
  ChevronRight: _Chevron.ChevronRight,
  ChevronLeft: _Chevron.ChevronLeft,
  ChevronDown: _Chevron.ChevronDown,
  ChevronUp: _Chevron.ChevronUp,
  Cross: _Cross.default,
  Delete: _Delete.default,
  ExternalLink: _ExternalLink.default,
  Highlight: _Highlight.default,
  Info: _Info.default,
  Question: _Question.default,
  Spinner: _Spinner.default,
  Car: _Car.default,
  Boat: _Boat.default,
  Home: _Home.default,
  Legal: _Legal.default,
  Business: _Business.default,
  Health: _Health.default,
  Cost: _Cost.default,
  Education: _Education.default,
  Life: _Life.default,
  Print: _Print.default,
  Tick: _Tick.default,
  Pencil: _Pencil.default,
  TextBox: _TextBox.default,
  TickCircle: _TickCircle.default
};
var _default = Icons;
exports.default = _default;